import { create } from 'zustand';

interface StorageLimitExceededState {
  isOpen: boolean;
  show: () => void;
  close: () => void;
}

export const useStorageLimitExceededStore = create<StorageLimitExceededState>((set) => ({
  isOpen: false,
  show: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
